import { useSocialAccount } from '@g4g/social-account/components/SocialAccountProvider'
import useRecipientUsers from '../hooks/useRecipientUsers'

const useRecentRecipients = () => {
  const { socialAccount } = useSocialAccount()
  const { recentRecipients, error, loading } = useRecipientUsers()
  // Don't show the logged in account inside the recent section
  const recent = recentRecipients?.filter((h) => h.cosId !== socialAccount?.userData.userId)

  return {
    recent,
    // !cosId to show only if not logged in so we don't show
    // two spinners and errors
    loading: loading && !socialAccount?.userData.userId,
    error: error && !socialAccount?.userData.userId,
  }
}

export default useRecentRecipients
